import { render } from "./TestCode.vue?vue&type=template&id=0742644b"
import script from "./TestCode.vue?vue&type=script&lang=js"
export * from "./TestCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__